<template>
  <v-container class="grey lighten-5 pt-0 mt-0" fluid>
    <v-row no-gutters align-centre>
      <v-col cols="12">
        <!-- Carousel -->
        <v-row no-gutters>
          <v-col cols="12">
            <v-card class="mb-4">
              <v-carousel cycle continuous interval="5000">
                <!--Slide 1-->
                <v-carousel-item
                  :src="require('../assets/photos/backgrounds/DSCF0981.jpeg')"
                >
                  <v-row class="fill-height" align="center" justify="center">
                    <v-col cols="12">
                      <v-spacer />
                      <h1  class="display-3 text-center">Welcome To The European Palm Society</h1>
                    </v-col>
                    <v-spacer />
                  </v-row>
                </v-carousel-item>

                <!--Slide 2-->
                <v-carousel-item
                  :src="require('../assets/photos/backgrounds/DSCF0971.jpeg')"
                >
                </v-carousel-item>

                <!--Slide 3-->
                <v-carousel-item
                  :src="require('../assets/photos/backgrounds/SAM_0042.jpeg')"
                >
                </v-carousel-item>

                <!--Slide 4-->
                <v-carousel-item
                  :src="require('../assets/photos/backgrounds/DSC01591.jpeg')"
                >
                </v-carousel-item>
              </v-carousel>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <!-- Text Column 1 -->
          <v-col cols="12" sm="4">
            <v-card class="pa-2">
              <v-card-title class="wrapfullwords">The European Palm Society</v-card-title>

<v-card-text class="wrapfullwords black-text">Founded in 1991, the European Palm Society (EPS) champions and is dedicated to the growing of palms and other exotic
plants across Europe and other Temperate areas of the world.</v-card-text>
<v-card-text class="wrapfullwords black-text">The Society is affiliated to the <a href="http://www.palms.org/" target="_blank">International Palm Society</a> and is a non-profit organisation. We recognise that many
other areas of the world experience similar climatic conditions to those in Europe and therefore welcome sharing the
experiences and knowledge of growers all around the globe.</v-card-text>

<v-card-text class="wrapfullwords black-text">The main goal of the EPS is promoting the pushing of boundaries in growing many types of palms and exotics outdoors that
you would often not expect to see. We also encourage the cultivation of more tropical &amp; sub-tropical species in our
homes, conservatories and glasshouses.</v-card-text>

<v-card-text class="wrapfullwords black-text">We communicate and share experiences through our website, discussion forum, Facebook page or personally via garden
visits. We have an online archive of our former journal ‘Chamaerops’ and other documents relevant to growing and
appreciating palms and exotic plants. Through all of these methods we share ideas and knowledge of the successful
cultivation and study of palms &amp; exotic plants. Above all the EPS is run by members, for members, and relies on that
active support and participation.</v-card-text>

            </v-card>
          </v-col>

          <!-- Text Column 2 -->
          <v-col cols="12" sm="4" v-if="newsData">
            <v-card class="pa-0 ma-0">
              <v-card-title class="wrapfullwords">EPS News</v-card-title>

              <v-card
                class="ma-0 pa-0"
                v-for="newsArticle in newsData.slice(0, 3)"
                :key="newsArticle.id"
                elevation="0"
              >
              <p class="pa-0 ma-0 pr-4">
                <v-card-title style="word-break: break-word"
                  ><router-link to="/news">{{
                    newsArticle.title
                  }}</router-link></v-card-title
                >
                <v-card-text style="overflow:hidden;" class="black-text" v-html="atMax2Paragraphs(newsArticle.content)">
                </v-card-text>
              </p>
              </v-card>
            </v-card>
          </v-col>

          <!-- Text Column 3 -->
          <v-col cols="12" sm="4">
            <v-card class="pa-2">
              <v-card-title class="wrapfullwords">Palm Database</v-card-title>
              <v-card-text class="black-text"
                >The <router-link to="/palminfo">Palm Database</router-link> is an
                exciting long term project where we would like over time to gather
                submissions from members of their experiences of growing palms and other
                exotic plants. The idea is not to end up with a check list of all the
                palms of the world but to concentrate on those we are growing. The
                resource we create will be publicly accessible so we can share our
                experiences with as many people as possible.</v-card-text
              >
              <v-card-text class="black-text"
                >It will be good to build a picture of how the plants perform across the
                varied climates and conditions we all garden under. Over time we should
                get a good reference for temperature ranges the plants are experiencing
                and what impact that has, tips for seed germination, soil preferences and
                importantly photographs of the plants. If we can build these reports from
                many members we get an excellent reference of data for each
                plant.</v-card-text
              >
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dateFunctions from "@/functions/dateFunctions";

export default {
  name: "Home",
  data: () => ({
    newsData: null,
    updatedNewsData: null, //TODO Delete
    server_url: "hello",
  }),
  methods: {
    getArticleSummary(articleContent) {
      return articleContent.substring(0, 250);
    },
    atMax2Paragraphs(text) {
      return text.split("<br").slice(0, 4).join("<br");
    },
    formatDateTime(datetime) {
      return dateFunctions.formatPalmDateTime(datetime);
    },
    async getNews() {
      const res = await fetch(process.env.VUE_APP_SERVER_URL + "/getAllNews", {
        method: "get",
      });
      const data = await res.json();
      this.newsData = data.result;
    },
  },
  beforeMount() {
    this.server_url = process.env.SERVERURL;
    this.getNews();
  },
};
</script>

<style>
.wrapfullwords {
  word-break: break-word;
}
</style>